import React, { useState } from "react";
import { Container, Box, Grid, Collapse } from "@material-ui/core";
import { Apps as SwissGroupGalleryIcon } from "@material-ui/icons";
import clsx from "classnames";

import ButtonSmg from "../ButtonSmg";
import EmergencyNumberBar from "../EmergencyNumberBar";
import LinkEcco, { WrappedLinkRouter } from "../Link";
import { SwissGroupGallery } from "../SwissGroupGallery";
import HeaderMenu from "../HeaderMenu";

import { useStyles } from "../../hooks";
import styles from "./styles";

import moment from 'moment';
import { PUBLICURL } from "../../main_config";
import menuItems from "../../data/menu_links";
import menuOptions from "../../data/info_header_menu";
import HeaderOption from "../HeaderOption";
import DialogModalGenerico from "../Modal/DialogModalGenerico";

import { useHistory } from "react-router-dom";
import ImportantMessageDialog from "../ImportantMessageDialog";

const Header = () => {
  const classes = useStyles(styles);
  const [selectedHeaderItem, setselectedHeaderItem] = useState("");
  const [selectedHeaderOption/*, setSelectedHeaderOption*/] = useState(menuOptions[0].value);
  
  const showModal = moment().isBetween(
    moment("2025-06-02T00:00:00"),
    moment("2025-06-20T20:00:00")
  );
  const isMaintenance = moment().isBetween(
    moment("2025-06-19T23:59:59"),
    moment("2025-06-20T20:00:00")
  );
  const [open, setOpen] = useState(false);

  let history = useHistory();

  const renderMenuOptions = () => (
    <HeaderOption
      title={selectedHeaderOption}
      elements={menuOptions}
      fixed={true}
      id={`headerMenuOptions`}
    />
  );

  const renderTopIcons = () => (
    <Grid container>
      <Grid item md={12} className={classes.topIconsContainer}>
        <Grid container justify="flex-end" alignItems="center">
          <Box
            display="flex"
            justifyContent="flex-end"
            flex={1}
            className={classes.eccoLinks}
          >
            <Box
              component="span"
              marginRight="4px"
              marginTop="9px"
              letterSpacing={0.2}
            >
              Estoy en el sitio de:&nbsp;
            </Box>
            {renderMenuOptions()}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );

  const renderLinks = () => {
    return (
      <Box
        display="flex"
        justifyContent="flex-end"
        flex={1}
        className={classes.eccoLinks}
      >
        {
          menuItems.filter(menu => menu.key !== "productos/consulta")
            .map(menu => (
              <HeaderMenu
                key={menu.key}
                item={menu}
                onClick={setselectedHeaderItem}
              />
            ))
        }
      </Box>
    );
  };

  const renderModal = () => {
    return (
      <DialogModalGenerico
        isMaintenance={isMaintenance}
        open={open}
        handleClose={handleClose}
        title="Mantenimiento"
      />
    );
  }

  const handleIngresarClick = e => {
    e.preventDefault();
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
    !isMaintenance && window.open("/individuales/login", "_blank");
  }

  
/***************************************************************
Validación de fecha que se mostrará en los días definidos
***************************************************************/
  
const [openVO, setOpenVO] = useState(false);
const [redirectPath, setRedirectPath] = useState(""); // Guarda la URL de destino


 /* Asociarme para durante */

 const handleOpenAsociarme  = () => {
  //const nowArg = moment().tz("America/Argentina/Buenos_Aires");
  const now = moment();

 // const startDate = moment.tz("2025-06-19 00:00:00", "America/Argentina/Buenos_Aires");
 // const endDate = moment.tz("2025-06-21 23:59:59", "America/Argentina/Buenos_Aires");

  const startDate = moment("2025-06-20T00:00:00");
  const endDate = moment("2025-06-20T20:00:00");

  if (now.isBetween(startDate, endDate, null, "[]")) {
    setOpenVO(true);
    setRedirectPath("");
  } else {
    history.push("/productos/consulta");
  }
};

// const handleClose = () => setOpen(false);

const handleCloseVO = () => {
  setOpenVO(false);
  if (redirectPath) {
    history.push(redirectPath); // Solo redirige si hay una ruta establecida
    setRedirectPath(""); // Resetea para evitar redirecciones no deseadas
  }
}; 

/***************************************************************
Fin validación de fecha que se mostrará en los días definidos
***************************************************************/


  // const renderHeaderMenuContent = () => {

  // }

  // const renderHeaderMenuSites = () => {

  // }

  // const renderMobile = () => {

  // }

  return (
    <Box
      className={classes.root}
      onMouseLeave={() => setselectedHeaderItem("")}
    >
      <EmergencyNumberBar />
      <Box className={classes.contentWrap}>
        {renderTopIcons()}
        <Box
          display="flex"
          alignItems="center"
          className={classes.headerContainer}
        >
          <LinkEcco to="/" className={classes.eccoLogo}>
            <img
              src={`${PUBLICURL}/assets/images/ecco_color.png`}
              alt="Ecco"
              className={classes.logo}
            />
          </LinkEcco>
          {renderLinks()}
          <Box className={classes.eccoButtonsContainer}>
            <ButtonSmg
              id="btn-asociarme"
              theme="material"
              content="Quiero asociarme"
              variant="outlined"
              buttonNav
              component={WrappedLinkRouter}
              to="/productos/consulta"
              target="_self"
              /* onClick={ showModal ? handleIngresarClick : null } */
              onClick={(e) => {
                e.preventDefault();
                handleOpenAsociarme();
              }} 
            />
            <ButtonSmg
              id="btn-ingresar"
              theme="material"
              color="primary"
              content="Ingresar"
              buttonNav
              component={WrappedLinkRouter}
              to="/login"
              target="_blank"
              onClick={ showModal ? handleIngresarClick : null }
            />
          </Box>
          <Box
            className={clsx(classes.eccoLink, classes.swissGroupIconWrapped, {
              [classes.active]: selectedHeaderItem === "logos"
            })}
            role="presentation"
            onMouseEnter={() => setselectedHeaderItem("logos")}
          >
            <SwissGroupGalleryIcon fontSize="large" />
          </Box>
        </Box>
      </Box>
      <Collapse
        in={selectedHeaderItem === "logos"}
        timeout={{
          enter: 150,
          exit: 150
        }}
      >
        <Box className={classes.headerMenu}>
          <Container>
            <SwissGroupGallery />
          </Container>
        </Box>
      </Collapse>
      { showModal && renderModal() }

      <ImportantMessageDialog open={openVO} onClose={handleCloseVO} />

    </Box>
  );
};

// Header.propTypes = {

// }

export default Header;
